import $ from 'jquery'
import {htmlEscape} from "../../utils";

export default function ActChoose(){
}

let win = window.top || window;

ActChoose.prototype.getChoose = function (data,type,callback) {
    this.callback = callback;
    let content = "<!DOCTYPE html>\n" +
        "<html lang=\"zh-CN\">\n" +
        "<head>\n" +
        "<meta charset=\"utf-8\">\n" +
        "<title>选择</title>\n" +
        "<link rel=\"stylesheet\" href=\"/cm-sites-activiti/css/jquery-labelauty.css\">\n" +
        "<style>\n" +
        "ul { list-style-type: none;padding-top: 20px;}\n" +
        "li { display: inline-block;}\n" +
        "li { padding: 0px 10px;}" +
        ".dowebok{height: 300px;overflow-y: auto; }\n" +
        "input.labelauty + label { font: 12px \"Microsoft Yahei\";}\n" +
        "</style>\n" +
        "</head>\n" +
        "\n" +
        "<body><ul class=\"dowebok\" style='padding: 15px;'>";

    $.each(data,function(index,item){
        if(type == "activitiUsers"){
            content += "<li><input value='"+ item.id + "'  id='ACT_CHOOSE"+ item.id +"' class='actChooseCheckbox' type=\"checkbox\" name=\"choose\" data-labelauty=\"" + htmlEscape(item.first) + "\"></li>";
        }else {
            content += "<li><input value='" + item.id + "' id='ACT_CHOOSE"+ item.id +"' class='actChooseCheckbox' type=\"checkbox\" name=\"choose\" data-labelauty=\"" + htmlEscape(item.name) + "\"></li>";
        }
    });
    content += "</ul>" +
        "</body>\n" +
        "</html>";

    win.layer.open({
        content: content,
        type: 1,
        btn: ['确定', '取消']
        , area: '500px'
        ,cancel: function(index, layero){
            win.layer.close(index);
            win.layer.closeAll("loading");
            return false;
         },end: function(){
            win.layer.closeAll("loading");
            return false;
        },success: function(){
            $.getScript("/cm-sites-activiti/js/jquery-labelauty.js",function () {
                $('.actChooseCheckbox').labelauty();
            })
         },yes : function(index){
            let value = [];
            $("input[name='choose']:checkbox").each(function (index,item) {
                if ($(this).attr("checked")|| this.checked ) {
                    value[value.length] = $(this).val();
                }
            });
            if(value.length < 1){
                alert("请至少选择一项");
                return;
            }else{
                let callbackValue ={};
                if(type == "activitiUsers" || type == "users"){
                    callbackValue.activitiUsers =value;
                }else if(type == ""){
                    callbackValue.remarks =value;
                }else if(type == null){
                    callbackValue.data = value;
                }
                callbackValue.type = type;
                callback(callbackValue);
            }
        },btn2: function(index, layero){
            win.layer.close(index);
            win.layer.closeAll("loading");
        }
    });
}
